// extracted by mini-css-extract-plugin
export default {"personList":"PersonList_personList__G2J+F"};